import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Collapse from "@mui/material/Collapse";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import useAuth from "../../hooks/useAuth";
import { allItemTop, userItems } from "../../constants/navbarList";

const SideNav = ({ onNavigate }) => {
  const { user } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  const listItemTop = user.admin ? allItemTop : userItems;

  // Expand the group containing the current route by default
  const [openGroup, setOpenGroup] = useState(
    () =>
      listItemTop.find(
        (item) => item.subMenu && location.pathname.startsWith(`${item.to}/`)
      )?.text ?? null
  );

  const toggleGroup = (text) =>
    setOpenGroup((current) => (current === text ? null : text));

  const handleLogout = () => {
    localStorage.clear();
    nav("/login");
  };

  return (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {listItemTop.map((list) =>
          list.subMenu && list.subMenu.length ? (
            <React.Fragment key={list.text}>
              <ListItemButton onClick={() => toggleGroup(list.text)}>
                <ListItemText primary={list.text} />
                {openGroup === list.text ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse in={openGroup === list.text} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {list.subMenu.map((eachSubMenu) => {
                    const to = `${list.to}/${eachSubMenu.to}`;
                    return (
                      <ListItemButton
                        key={to}
                        component={Link}
                        to={to}
                        selected={location.pathname === to}
                        onClick={onNavigate}
                        sx={{ pl: 4 }}
                      >
                        <ListItemText primary={eachSubMenu.text} />
                      </ListItemButton>
                    );
                  })}
                </List>
              </Collapse>
            </React.Fragment>
          ) : (
            <ListItemButton
              key={list.text}
              component={Link}
              to={list.to}
              selected={location.pathname === list.to}
              onClick={onNavigate}
            >
              <ListItemText primary={list.text} />
            </ListItemButton>
          )
        )}
      </List>
      <Divider />
      <List>
        <ListItemButton onClick={handleLogout}>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
    </div>
  );
};

export default SideNav;
